import apiClient from '@/services/PortalClient'

const state = () => ({
  profileLicenseList: [],
  profileLicenseListLoaded: false
})

const getters = {
  profileLicenseOptions: (state) => {
    return state.profileLicenseList.map(profileLicense => ({
      name: profileLicense,
      value: profileLicense
    }))
  },
  profileLicenseListLoaded: (state) => {
    return state.profileLicenseListLoaded
  }
}

const actions = {
  loadProfileLicenseList ({ commit }) {
    return apiClient.sendRequest(
      'GET',
      'admin/api/v2/admins/license/entries'
    )
      .then(({ payload }) => {
        commit('setProfileLicenseList', payload)
        commit('setProfileLicenseListLoaded')
      })
  }
}

const mutations = {
  setProfileLicenseList (state, currencyList) {
    state.profileLicenseList = currencyList
  },
  setProfileLicenseListLoaded (state) {
    state.profileLicenseListLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
